import React, {useEffect, useState} from "react";
import DynamicSvg from "../elements/DynamicSvg.js";
import {UserUtils} from "../../utils/UserUtils.js";

export default function AppsDashboard({registeredApplets = [], registeredLinks = []})
{
    const [applets, setApplets] = useState([]);
    const [links, setLinks] = useState([]);
    const [downloads, setDownloads] = useState([]);

    const [os, setOs] = useState(null);

    useEffect(() =>
    {
        const userAgent = window.navigator.userAgent;
        console.log("User agent: " + userAgent);
        if (userAgent.toLowerCase().includes("win")) setOs("Windows");
        else if (userAgent.toLowerCase().includes("mac")) setOs("macOS");
        else if (userAgent.toLowerCase().includes("linux")) setOs("Linux");

        fetch("api/public/registered-components")
            .then(response => response.json())
            .then(registeredComponents =>
                {
                    setApplets(registeredComponents.applets);
                    setLinks(registeredComponents.links);
                    setDownloads(registeredComponents.downloads);
                }
            );
    }, []);

    return (
        <div id="content-area">
            {
                applets.length > 0 &&
                (
                    <div id="apps-area">
                        <div className="page-header">
                            <h1 className="page-title">Apps</h1>
                            <div className="divider"></div>
                        </div>
                        <div id="applet-container" className="module-container">
                            {
                                applets.map((applet) => (
                                    <a key={applet.name} href={applet.targetUrl}>
                                        <div
                                            id={`${applet.name}-module-button`}
                                            className="module-button"
                                            title={applet.name}
                                        >
                                            {
                                                applet.logoResourcePath.toLowerCase().endsWith("svg") ?
                                                (
                                                    <>
                                                        <DynamicSvg className="content-layer" src={applet.logoResourcePath}/>
                                                        <DynamicSvg className="embed-layer" src={applet.logoResourcePath}/>
                                                        <DynamicSvg className="embed-layer2" src={applet.logoResourcePath}/>
                                                        <DynamicSvg className="glow-layer" src={applet.logoResourcePath}/>
                                                    </>
                                                ) :
                                                (
                                                    <img src={applet.logoResourcePath} alt="applet-logo"/>
                                                )
                                            }
                                        </div>
                                    </a>
                                ))
                            }
                        </div>
                    </div>
                )
            }
            {
                links.length > 0 &&
                (
                    <div id="links-area">
                        <div className="page-header">
                            <h1 className="page-title">Links</h1>
                            <div className="divider"></div>
                        </div>
                        <div id="links-container" className="module-container">
                            {
                                links.map((link) => (
                                    <a key={link.name} href={link.targetUrl}>
                                        <div id={`${link.name}-module-button`} className="link-button" title={link.name}>
                                            {
                                                link.logoOverrideUrl != null ?
                                                (
                                                    link.logoOverrideUrl.toLowerCase().endsWith("svg") ?
                                                        (
                                                            <>
                                                                <DynamicSvg className="content-layer" src={link.logoOverrideUrl}/>
                                                                <DynamicSvg className="embed-layer" src={link.logoOverrideUrl}/>
                                                                <DynamicSvg className="embed-layer2" src={link.logoOverrideUrl}/>
                                                                <DynamicSvg className="glow-layer" src={link.logoOverrideUrl}/>
                                                            </>
                                                        ) :
                                                        (
                                                            <img src={link.logoOverrideUrl} alt="download-logo"/>
                                                        )
                                                )
                                                :
                                                (
                                                    <img src={`${link.targetUrl}/favicon.ico`} alt="download-logo"/>
                                                )
                                            }
                                        </div>
                                    </a>
                                ))
                            }
                        </div>
                    </div>
                )
            }
            {
                downloads.length > 0 &&
                (
                    <div id="links-area">
                        <div className="page-header">
                            <h1 className="page-title">Downloads</h1>
                            <div className="divider"></div>
                        </div>
                        <div id="links-container" className="module-container">
                            {
                                downloads.filter(d => d.dependentOs.toLowerCase() === os.toLocaleLowerCase()).map((download) => (
                                    <a key={download.name} href={download.targetUrl} target="_blank">
                                        <div id={`${download.name}-module-button`} className="link-button" title={download.name}>
                                            {
                                                download.logoResourcePath.toLowerCase().endsWith("svg") ?
                                                    (
                                                        <>
                                                            <DynamicSvg className="content-layer" src={download.logoResourcePath}/>
                                                            <DynamicSvg className="embed-layer" src={download.logoResourcePath}/>
                                                            <DynamicSvg className="embed-layer2" src={download.logoResourcePath}/>
                                                            <DynamicSvg className="glow-layer" src={download.logoResourcePath}/>
                                                        </>
                                                    ) :
                                                    (
                                                        <img src={download.logoResourcePath} alt="download-logo"/>
                                                    )
                                            }
                                        </div>
                                    </a>
                                ))
                            }
                        </div>
                    </div>
                )
            }
        </div>
    );
};
